const matchesConstants = {
  RECENTLY_VIEWED_MEMBERS: "RECENTLY_VIEWED_MEMBERS",
  CLEAR_RECENTLY_VIEWED_MEMBERS: "CLEAR_RECENTLY_VIEWED_MEMBERS",
  GET_MATCHED_MEMBER_PROFILE: "GET_MATCHED_MEMBER_PROFILE",
  CLEAR_MATCHED_MEMBERS: "CLEAR_MATCHED_MEMBERS",
  GET_LIKED_MEMBERS: "GET_LIKED_MEMBERS",
  CLEAR_LIKED_MEMBERS: "CLEAR_LIKED_MEMBERS",
  GET_SAVED_MEMBERS: "GET_SAVED_MEMBERS",
  CLEAR_SAVED_MEMBERS: "CLEAR_SAVED_MEMBERS",
  GET_SHORTLISTED_MEMBERS: "GET_SHORTLISTED_MEMBERS",
  CLEAR_SHORTLISTED_MEMBERS: "CLEAR_SHORTLISTED_MEMBERS",
  GET_EXPRESSED_INTEREST_MEMBERS: "GET_EXPRESSED_INTEREST_MEMBERS",
  CLEAR_EXPRESSED_INTEREST_MEMBERS: "CLEAR_EXPRESSED_INTEREST_MEMBERS",
  GET_FAVORITE_MEMBERS: "GET_FAVORITE_MEMBERS",
  CLEAR_FAVORITE_MEMBERS: "CLEAR_FAVORITE_MEMBERS",
  GET_PROFILE_VISITORS: "GET_PROFILE_VISITORS",
  CLEAR_PROFILE_VISITORS: "CLEAR_PROFILE_VISITORS",
  GET_PENDING_INVITATIONS: "GET_PENDING_INVITATIONS",
  CLEAR_PENDING_INVITATIONS: "CLEAR_PENDING_INVITATIONS",
  GET_ACCEPT_INVITATIONS: "GET_ACCEPT_INVITATIONS",
  CLEAR_ACCEPT_INVITATIONS: "CLEAR_ACCEPT_INVITATIONS",
  GET_PEOPLE_WHO_LIKED_ME: "GET_PEOPLE_WHO_LIKED_ME",
  CLEAR_PEOPLE_WHO_LIKED_ME: "CLEAR_PEOPLE_WHO_LIKED_ME",
  GET_PEOPLE_EXPRESSED_INTEREST_IN_ME: "GET_PEOPLE_EXPRESSED_INTEREST_IN_ME",
  CLEAR_PEOPLE_EXPRESSED_INTEREST_IN_ME:
    "CLEAR_PEOPLE_EXPRESSED_INTEREST_IN_ME",
  GET_CONNECTED_MEMBERS: "GET_CONNECTED_MEMBERS",
  CLEAR_CONNECTED_MEMBERS: "CLEAR_CONNECTED_MEMBERS",
  CHANGE_LAST_RESULT_FOR_MATCHES: "CHANGE_LAST_RESULT_FOR_MATCHES",
  LOAD_MORE_MATCH_RESULTS: "LOAD_MORE_MATCH_RESULTS",
  MARK_ALL_PROFILE_VISITORS_AS_READ: "MARK_ALL_PROFILE_VISITORS_AS_READ",
  MARK_ALL_INVITATIONS_RECEIVED_AS_READ:
    "MARK_ALL_INVITATIONS_RECEIVED_AS_READ",
  MARK_ALL_CONNECTED_MEMBERS_AS_READ: "MARK_ALL_CONNECTED_MEMBERS_AS_READ",
  MARK_ALL_EXPRESSED_INTERESTS_AS_READ: "MARK_ALL_EXPRESSED_INTERESTS_AS_READ",
  MARK_ALL_LIKES_AS_READ: "MARK_ALL_LIKES_AS_READ"
};
export default matchesConstants;



// WEBPACK FOOTER //
// ./src/_constants/matchesConstants.js